import { render } from "./autorizacion_canales_contacto_comunicacion.vue?vue&type=template&id=090fd187"
import script from "./autorizacion_canales_contacto_comunicacion.vue?vue&type=script&lang=js"
export * from "./autorizacion_canales_contacto_comunicacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__